<template>
  <a-card :bordered="false" title="经营总览" :headStyle="{fontSize:'18px'}">
    <span slot="extra" class="title-description">数据统计为昨日数据</span>
    <div class="side">交易数据</div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>支付订单数</span>
          <p>{{ salesData.payOrderCount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付用户数</span>
          <p>{{ salesData.payUserCount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付金额（元）</span>
          <p><span>￥</span>{{ salesData.payTotalAmount }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>支付转化率</span>
          <p>{{ salesData.payRatio }}<span>%</span></p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>客单均价（元）</span>
          <p><span>￥</span>{{ salesData.customerAveragePrice }}</p></div>
      </a-col>
    </a-row>
    <div class="side">商品数据</div>
    <a-row class="row-style">
      <a-col :span="5">
        <div class="head-info"><span>商品访客数</span>
          <p>{{ productData.productVisitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>商品浏览量</span>
          <p>{{ productData.productViewNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>商品支付件/份数</span>
          <p>{{ productData.productPaymentNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>被访问商品总数</span>
          <p>{{ productData.totalProductsVisitedNumber }}</p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>商品收藏总数</span>
          <p>{{ productData.totalProductCollectionNumber }}</p></div>
      </a-col>
    </a-row>
    <div class="side" v-if="merchantType==1||merchantType==2">用户数据</div>
    <a-row class="row-style" v-if="merchantType==1||merchantType==2">
      <a-col :span="5">
        <div class="head-info"><span>登录用户数</span>
          <p>{{ userData.loginNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>新增用户数</span>
          <p>{{ userData.newMemberNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>下单用户数</span>
          <p>{{ userData.memberOrderNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>收藏商品用户数</span>
          <p>{{ userData.memberFavoriteNumber }}</p></div>
      </a-col>
      <a-col :span="4">
        <div class="head-info"><span>累计用户数</span>
          <p>{{ userData.memberTotalNumber }}</p></div>
      </a-col>
    </a-row>
    <div class="side" v-if="merchantType==1||merchantType==2">流量数据</div>
    <a-row class="row-style" v-if="merchantType==1||merchantType==2">
      <a-col :span="5">
        <div class="head-info"><span>浏览量</span>
          <p>{{ flowData.scanNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>访客数</span>
          <p>{{ flowData.visitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>新访客</span>
          <p>{{ flowData.newVisitorNumber }}</p></div>
      </a-col>
      <a-col :span="5">
        <div class="head-info"><span>平均停留时间</span>
          <p>{{ flowData.avgTime }}</p></div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import moment from 'moment'

export default {
  name: 'ManagePandect',
  data() {
    return {
      startTime: '',
      endTime: '',
      merchantType: 0,
      salesData: {
        payOrderCount: 0,
        payUserCount: 0,
        payTotalAmount: 0,
        payRatio: 0,
        customerAveragePrice: 0
      },
      productData: {
        productVisitorNumber: 0,
        productViewNumber: 0,
        productPaymentNumber: 0,
        totalProductsVisitedNumber: 0,
        totalProductCollectionNumber: 0
      },
      flowData: {
        scanNumber: 0,
        visitorNumber: 0,
        newVisitorNumber: 0,
        avgTime: '00:00'
      },
      userData: {
        loginNumber: 0,
        newMemberNumber: 0,
        memberOrderNumber: 0,
        memberFavoriteNumber: 0,
        memberTotalNumber: 0
      }
    }
  },
  mounted() {
    this.yesterday()
    this.getMerchantNewField()
  },
  methods: {
    moment,
    yesterday() {
      var yesterday = moment().subtract('days', 1).format('YYYY-MM-DD')
      this.startTime = yesterday
      this.endTime = yesterday
      this.getSalesData()
      this.getProductStatisticsData()
      this.getMerchantFlowStatistic()
      this.getMemberOverviewData()
      this.getLogUtils().logWithTag('startTime', this.startTime)
      this.getLogUtils().logWithTag('endTime', this.endTime)
    },
    getMerchantNewField() {
      this.getHttpServices().getUserService().post('api/v2/merchant/getMerchantNewField/' + this.$store.getters.userInfo.merchantId, {})
        .then(res => {
          this.merchantType = res.merchantType
        }).catch(reason => this.getLogUtils().errorWithTag('getRolePermissions', reason))
    },
    getSalesData() {
      this.getHttpServices().getOrderService().post('order/v2/OrderStatistic/getOrderStatistic', {
        endTime: this.startTime,
        startTime: this.endTime
      }).then(res => {
        this.salesData = res
        this.getLogUtils().logWithTag('交易数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getProductStatisticsData() {
      this.getHttpServices().getProService().post('api/v2/productStatistics/getProductStatisticsRealTime', {
        endDay: this.startTime,
        startDay: this.endTime
      }).then(res => {
        this.productData = res
        this.getLogUtils().logWithTag('商品数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getMerchantFlowStatistic() {
      this.getHttpServices().getUserService().post('api/v2/statistics/getMerchantFlowRealTime', {
        endDay: this.startTime,
        startDay: this.endTime
      }).then(res => {
        this.flowData = res
        this.getLogUtils().logWithTag('流量数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getMemberOverviewData() {
      this.getHttpServices().getUserService().post('api/v2/statistics/getMerchantMemberStatisticRealTime', {
        endDay: this.endTime,
        startDay: this.startTime
      }).then(res => {
        this.userData = res
        this.getLogUtils().logWithTag('用户数据', res)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style lang="less">
.side {
  padding-left: 10px;
  line-height: 18px;
  font-size: 16px;
  border-left: 1px solid cornflowerblue;

}

.row-style {
  padding: 20px;
  border-radius: 3px;
  margin: 15px 0;
  border: 1px solid #d5d5d5;
}

.title-description {
  position: absolute;
  left: 120px;
  top: 20px;
}

.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  span {
    color: rgba(0, 0, 0, .45);
    display: inline-block;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 4px;
  }

  p {
    color: rgba(0, 0, 0, .85);
    font-size: 24px;
    line-height: 32px;
    margin: 0;
  }
}
</style>
